import React from 'react';
import { ContentGroup, ContentStatus } from '../types';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';

interface ProgressSummaryProps {
    groupedContents: ContentGroup[];
    getContentStatus: (attempt: ContentGroup['mostRecentAttempt']) => ContentStatus;
}

const ProgressSummary: React.FC<ProgressSummaryProps> = ({ groupedContents, getContentStatus }) => {

    const successfullyCompleted = groupedContents.filter(
        (group) => getContentStatus(group.mostRecentAttempt) === "Success"
    ).length;

    const notCompleted = groupedContents.length - successfullyCompleted;

    return (
        <div className="row">
            <div className="col-md-6 col-xl-4">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex align-items-center">
                            <span className="icon-box bg-primary-transparent me-3 flex-shrink-0">
                                <ImageWithBasePath
                                    src="assets/img/icon/graduation.svg"
                                    alt=""
                                />
                            </span>
                            <div>
                                <span className="d-block">Total Contents</span>
                                <h4 className="fs-24 mt-1">
                                    {groupedContents.length}
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-xl-4">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex align-items-center">
                            <span className="icon-box bg-success-transparent me-3 flex-shrink-0">
                                <ImageWithBasePath
                                    src="assets/img/icon/bookmark.svg"
                                    alt=""
                                />
                            </span>
                            <div>
                                <span className="d-block">
                                    Successfully Completed
                                </span>
                                <h4 className="fs-24 mt-1">
                                    {successfullyCompleted}
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-xl-4">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex align-items-center">
                            <span className="icon-box bg-secondary-transparent me-3 flex-shrink-0">
                                <ImageWithBasePath
                                    src="assets/img/icon/book.svg"
                                    alt=""
                                />
                            </span>
                            <div>
                                <span className="d-block">Not Completed</span>
                                <h4 className="fs-24 mt-1">
                                    {notCompleted}
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(ProgressSummary);